<template>
  <div class="kg-rightbar" v-if="!btnActiveBus.value">
    <div v-if="show" class="kg-rightbar-panel">
      <el-tabs v-model="activeName">
        <!-- 知识点 Tab -->
        <el-tab-pane label="知识点" name="node">
          <div class="kg-rightbar-list">
            <div v-for="item in graphNodes" :key="item.id" class="kg-rightbar-item">
              <el-tooltip :content="item.name" placement="left" effect="light">
                <div
                  class="kg-rightbar-item-text"
                  @mouseenter="menuNodeEnter(item)"
                  @mouseleave="menuNodeEdgeLeave(item)"
                >{{ item.name }}</div>
              </el-tooltip>
              <div class="kg-rightbar-item-actions">
                <el-tooltip content="添加关系" placement="bottom" effect="light">
                  <i class="el-icon-connection kg-icon-btn blue" @click="hanleAction('addEdge', item)"></i>
                </el-tooltip>
                <el-tooltip content="编辑知识点" placement="bottom" effect="light">
                  <i class="el-icon-setting kg-icon-btn blue" @click="hanleAction('editNode', item)"></i>
                </el-tooltip>
                <el-tooltip content="删除知识点" placement="bottom" effect="light">
                  <i class="el-icon-delete kg-icon-btn red" @click="hanleAction('delNode', item)"></i>
                </el-tooltip>
              </div>
            </div>
          </div>
          <div class="kg-rightbar-footer">
            <el-button type="primary" size="small" @click="hanleAction('addNode')">添加知识点</el-button>
          </div>
        </el-tab-pane>

        <!-- 关系 Tab -->
        <el-tab-pane label="关系" name="edge">
          <div class="kg-rightbar-list">
            <div v-for="item in graphEdges" :key="item.id" class="kg-rightbar-item">
              <el-tooltip
                :content="getEdgeLabel(item)"
                placement="left"
                effect="light"
              >
                <div
                  class="kg-rightbar-item-text"
                  @mouseenter="menuEdgeEnter(item)"
                  @mouseleave="menuNodeEdgeLeave(item)"
                >{{ getEdgeLabel(item) }}</div>
              </el-tooltip>
              <div class="kg-rightbar-item-actions">
                <el-tooltip content="编辑关系" placement="bottom" effect="light">
                  <i class="el-icon-setting kg-icon-btn blue" @click="hanleAction('editEdge', item)"></i>
                </el-tooltip>
                <el-tooltip content="删除关系" placement="bottom" effect="light">
                  <i class="el-icon-delete kg-icon-btn red" @click="hanleAction('delEdge', item)"></i>
                </el-tooltip>
              </div>
            </div>
          </div>
          <div class="kg-rightbar-footer">
            <el-button type="primary" size="small" @click="hanleAction('addEdge')">添加关系</el-button>
          </div>
        </el-tab-pane>

        <!-- 超边 Tab -->
        <el-tab-pane label="超边" name="clusters">
          <div class="kg-rightbar-list">
            <el-tree
              :data="graphClusters"
              :props="treeProps"
              default-expand-all
              :expand-on-click-node="false"
            >
              <template slot-scope="{ node, data }">
                <div class="kg-rightbar-tree-item">
                  <div class="kg-rightbar-tree-text" :style="{ width: data.chapterId ? '210px' : '192px' }">
                    <template v-if="data.chapterId">
                      <span
                        @mouseenter="menuNodeEnter(data)"
                        @mouseleave="menuNodeEdgeLeave(data)"
                      >{{ node.label }}</span>
                    </template>
                    <template v-else>{{ node.label }}</template>
                  </div>
                  <div class="kg-rightbar-tree-actions">
                    <template v-if="data.chapterId">
                      <el-tooltip content="从超边中移除" placement="bottom" effect="light">
                        <i class="el-icon-close kg-icon-btn blue" @click="hanleAction('delClusterNode', data)"></i>
                      </el-tooltip>
                    </template>
                    <template v-else>
                      <el-tooltip content="添加知识点" placement="bottom" effect="light">
                        <i class="el-icon-plus kg-icon-btn blue" @click="hanleAction('addClusterNode', data)"></i>
                      </el-tooltip>
                      <el-tooltip content="编辑超边" placement="bottom" effect="light">
                        <i class="el-icon-setting kg-icon-btn blue" @click="hanleAction('editCluster', data)"></i>
                      </el-tooltip>
                      <el-tooltip content="删除超边" placement="bottom" effect="light">
                        <i class="el-icon-delete kg-icon-btn red" @click="hanleAction('delCluster', data)"></i>
                      </el-tooltip>
                    </template>
                  </div>
                </div>
              </template>
            </el-tree>
          </div>
          <div class="kg-rightbar-footer">
            <el-button type="primary" size="small" @click="hanleAction('addCluster')">添加超边</el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 折叠按钮 -->
    <div class="kg-rightbar-toggle" @click="show = !show">
      <i :class="show ? 'el-icon-arrow-right' : 'el-icon-arrow-left'"></i>
    </div>
  </div>
</template>

<script>
import { edgesOps } from '../hypergraph'

export default {
  name: 'KgRightbar',
  inject: ['graphNodes', 'graphEdges', 'graphClusters', 'graphAction', 'graphModule', 'btnActiveBus'],
  data() {
    return {
      activeName: 'node',
      show: true,
      treeProps: {
        children: 'knowledgeList',
        label: 'name',
      },
    }
  },
  methods: {
    hanleAction(type, data) {
      this.graphAction(type, data)
    },
    getEdgeLabel(item) {
      if (item.sourceKnowledge && item.targetKnowledge) {
        var relLabel = (edgesOps[item.relationType] || {}).labelText || ''
        return item.sourceKnowledge.name + '-' + item.targetKnowledge.name + ' (' + relLabel + ')'
      }
      return '-'
    },
    menuNodeEnter(data) {
      var graph = this.graphModule.value
      if (!graph) return
      try {
        var nodeData = graph.getNodeData()
        if (!nodeData || !nodeData.length) return
        var edgesData = graph.getEdgeData() || []
        var targetId = String(data.id)
        // 检查节点是否存在于图谱中
        var nodeExists = nodeData.some(function (item) { return String(item.id) === targetId })
        if (!nodeExists) return
        nodeData.forEach(function (item) { graph.setElementState(String(item.id), 'dim') })
        edgesData.forEach(function (item) { graph.setElementState(String(item.id), 'dim') })
        graph.setElementState(targetId, 'selected')
        edgesData.forEach(function (item) {
          if (String(item.source) === targetId || String(item.target) === targetId) {
            if (String(item.source) === targetId) {
              graph.setElementState(String(item.source), 'selected')
            } else {
              graph.setElementState(String(item.source), 'highlight')
            }
            if (String(item.target) === targetId) {
              graph.setElementState(String(item.target), 'selected')
            } else {
              graph.setElementState(String(item.target), 'highlight')
            }
            graph.setElementState(String(item.id), 'highlight')
          }
        })
      } catch (e) { /* ignore */ }
    },
    menuNodeEdgeLeave() {
      var graph = this.graphModule.value
      if (!graph) return
      try {
        var nodeData = graph.getNodeData()
        if (!nodeData || !nodeData.length) return
        var edgesData = graph.getEdgeData() || []
        nodeData.forEach(function (item) { graph.setElementState(String(item.id), '') })
        edgesData.forEach(function (item) { graph.setElementState(String(item.id), '') })
      } catch (e) { /* ignore */ }
    },
    menuEdgeEnter(data) {
      var graph = this.graphModule.value
      if (!graph) return
      try {
        var nodeData = graph.getNodeData()
        if (!nodeData || !nodeData.length) return
        var edgesData = graph.getEdgeData() || []
        var targetId = String(data.id)
        // 检查边是否存在于图谱中
        var edgeExists = edgesData.some(function (item) { return String(item.id) === targetId })
        if (!edgeExists) return
        nodeData.forEach(function (item) { graph.setElementState(String(item.id), 'dim') })
        edgesData.forEach(function (item) { graph.setElementState(String(item.id), 'dim') })
        graph.setElementState(targetId, 'highlight')
        edgesData.forEach(function (item) {
          if (String(item.id) === targetId) {
            graph.setElementState(String(item.source), 'highlight')
            graph.setElementState(String(item.target), 'highlight')
          }
        })
      } catch (e) { /* ignore */ }
    },
  },
}
</script>

<style scoped lang="less">
.kg-rightbar {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 10;
}
.kg-rightbar-panel {
  width: 300px;
  background: #fff;
  border-radius: 6px;
  padding: 10px;
  height: 100%;
  overflow: hidden;
}
.kg-rightbar-list {
  height: calc(100vh - 200px);
  overflow-y: auto;
}
.kg-rightbar-item {
  padding: 10px 0;
  position: relative;
  padding-right: 60px;
}
.kg-rightbar-item-text {
  font-size: 12px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  &:hover {
    color: #3e8fff;
  }
}
.kg-rightbar-item-actions {
  font-size: 12px;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
}
.kg-rightbar-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 10px;
}
.kg-rightbar-toggle {
  position: absolute;
  left: -18px;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(128, 128, 128, 0.5);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 60px;
  border-radius: 6px 0 0 6px;
  color: #fff;
}
.kg-rightbar-tree-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.kg-rightbar-tree-text {
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.kg-rightbar-tree-actions {
  display: flex;
  align-items: center;
}
.kg-icon-btn {
  cursor: pointer;
  margin-right: 4px;
  font-size: 14px;
  &.blue {
    color: #3e8fff;
  }
  &.red {
    color: #f56c6c;
  }
  &:hover {
    opacity: 0.7;
  }
}
</style>
